<template>
  <div class="all">
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>

    <div
      class="width100 margin-auto backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="关键词">
          <el-input placeholder="请输入关键词" v-model="input"></el-input>
        </el-form-item>
        <div class="pad-left20">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
        </div>
      </el-form>
      <span
        class="
          attention
          margin-top10 margin-bot10 margin-left20 margin-right20
          f14
        "
        @click="dialogVisibles = true"
        >新 增</span
      >
    </div>

    <!-- 检索 -->
    <el-skeleton
      class="width100 margin-top15"
      :loading="loading"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div
          class="
            width100
            margin-auto
            backwhite
            pad-top20
            border-rd3
            alldigitals
          "
        >
          <el-table :data="page" stripe class="eltable width98 margin-auto f14">
            <el-table-column
              label="关键词"
              align="left"
              v-if="columns[0].visible"
            >
              <template slot-scope="scope">
                <span
                  @click="viewdetails(scope.row)"
                  class="bluecolor cursorpointer"
                  >{{ scope.row.keyword }}</span
                ></template
              ></el-table-column
            >
            <el-table-column
              label="实用新型数量"
              align="center"
              prop="syxx"
              v-if="columns[1].visible"
            />
            <el-table-column
              label="发明专利数量"
              align="center"
              prop="fmzl"
              v-if="columns[2].visible"
            />
            <el-table-column
              label="外观专利数量"
              align="center"
              prop="wgzl"
              v-if="columns[3].visible"
            />
            <el-table-column
              label="专利总数"
              align="center"
              prop="allcont"
              v-if="columns[4].visible"
            />
            <el-table-column
              label="监控时间"
              align="center"
              prop="create_time"
              v-if="columns[5].visible"
            />
            <el-table-column
              label="数据更新时间"
              align="center"
              prop="update_time"
              v-if="columns[6].visible"
            />
            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
              v-if="columns[7].visible"
            >
              <template slot-scope="scope">
                <div class="cursorpointer">
                  <span style="color: #52c5cb" @click="viewdetails(scope.row)"
                    >查看详情</span
                  >
                  <span
                    class="pad-left10"
                    style="color: #52c5cb"
                    @click="removepro(scope.row)"
                    >取消监控</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="total != 0"
            class="
              width98
              margin-auto
              flex-betweennowrap
              pad-top20 pad-bot20
              pagination
            "
          >
            <span></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisibles"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <div class="f16 width98 textalign-left dimensional">新增监控</div>
      <div class="width98 margin-auto margin-top40">
        <p class="textalign-left">技术关键词</p>
        <el-input
          v-model="addinput"
          placeholder="请输入关键词"
          class="addinput"
        ></el-input>
      </div>
      <div class="textalign-right">
        <el-button @click="dialogVisibles = false">取 消</el-button>
        <el-button type="primary" @click="addproject()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
<script>
import {
  Technicalmonitoring,
  enttechmonitordelete,
  enttechmonitorsave,
} from "@/api/Center/Center.api";

import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      ruleForm: {
        pipo: "",
        name: "",
      },
      thisNum: 1,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      input: "",
      serchkey: true,
      dialogVisibles: false,
      addinput: "",
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      columns: [
        { key: 0, label: `关键词`, visible: true },
        { key: 1, label: `实用新型数量`, visible: true },
        { key: 2, label: `发明专利数量`, visible: true },
        { key: 3, label: `外观专利数量`, visible: true },
        { key: 4, label: `专利总数`, visible: true },
        { key: 5, label: `监控时间`, visible: true },
        { key: 6, label: `数据更新时间`, visible: true },
        { key: 7, label: `操作`, visible: true },
      ],
    };
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    // 添加技术监控项
    addproject() {
      enttechmonitorsave({ keyword: this.addinput }).then((res) => {
        if (res.data.code == 200) {
          this.drawers = false;
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          this.refresh();
          this.dialogVisibles = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 取消监控
    removepro(row) {
      this.$confirm("此操作将取消监控, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          enttechmonitordelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "取消成功",
                type: "success",
              });
              this.drawer = false;
              this.refresh();
            } else {
              this.drawer = false;
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 查看详情
    viewdetails(row) {
      window.sessionStorage.setItem("technicalkeyword", row.keyword);
      this.$router.push({
        path: "/development-Administration/Monitoring-page",
      });
    },
    submitForm() {
      Technicalmonitoring({
        _keywords: this.input,
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      Technicalmonitoring({
        _keywords: this.input,
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
            i.create_time = i.create_time.slice(0, 10);
            this.allcont = i.fmzl + i.syxx + i.wgzl;
            i.allcont = this.allcont;
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      Technicalmonitoring({
        _keywords: this.input,
        page: this.thisNum,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.page.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
            i.create_time = i.create_time.slice(0, 10);
            this.allcont = i.fmzl + i.syxx + i.wgzl;
            i.allcont = this.allcont;
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.thisNum = 1;
      Technicalmonitoring({
        page: this.thisNum,
      }).then((res) => {
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.page.forEach((i) => {
          i.update_time = i.update_time.slice(0, 10);
          i.create_time = i.create_time.slice(0, 10);
          this.allcont = i.fmzl + i.syxx + i.wgzl;
          i.allcont = this.allcont;
        });
        if (res.data.code == 200) {
          this.drawer = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      Technicalmonitoring({
        page: this.thisNum,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          const allcont = "";
          this.page.forEach((i) => {
            i.update_time = i.update_time.slice(0, 10);
            i.create_time = i.create_time.slice(0, 10);
            this.allcont = i.fmzl + i.syxx + i.wgzl;
            i.allcont = this.allcont;
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    Technicalmonitoring({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        const allcont = "";
        this.page.forEach((i) => {
          i.update_time = i.update_time.slice(0, 10);
          i.create_time = i.create_time.slice(0, 10);
          this.allcont = i.fmzl + i.syxx + i.wgzl;
          i.allcont = this.allcont;
        });
      } else {
        this.drawer = false;
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
}
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.btnn {
  width: 100%;
  height: 25%;
  margin: auto;
  border: none;
  background: white;
}
.addinput {
  width: 100%;
  margin: 10px auto 60px;
}
</style>